export const TABLE_HEADERS = [
  {
    header: "Group",
    key: "group",
    headerVisible: false,
    isRowHeader: true,
  },
  {
    header: "Est. Enrollment",
    key: "estEnrollment",
    headerVisible: true,
    isRowHeader: false,
  },
  {
    header: "Est. NTR",
    key: "estNetRevenue",
    headerVisible: true,
    unit: "currency",
    isRowHeader: false,
  },
  {
    header: "Est. Inst. Aid",
    key: "estInstitutionalAid",
    headerVisible: true,
    unit: "currency",
    isRowHeader: false,
  },
  {
    header: "Est. Tuition Discount Rate",
    key: "estTuitionDiscountRate",
    headerVisible: true,
    unit: "percent",
    isRowHeader: false,
  },
];
export const COST_OF_ATTENDANCE_TABLE_HEADERS = [
  {
    header: "Type",
    key: "type",
    headerVisible: false,
    isRowHeader: true,
  },
  {
    header: "2024",
    key: "lastYear",
    headerVisible: true,
    unit: "currency",
  },
  {
    header: "2025",
    key: "currentYear",
    headerVisible: true,
    unit: "currency",
  },
  {
    header: "% Change",
    key: "percentChange",
    headerVisible: true,
    unit: "percent",
  },
];
